import usePrivateAxios from '@/common/api/usePrivateAxios';
import { defaultTransformerResponse } from '@/common/constants/defaultTransformerResponse.constant';
import { Mapper } from '@/common/services/mapper';
import { MetaResponse } from '@/common/types/metaResponse';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

type UseBulkActionsEntriesInspectProps<T> = {
  filters?: {
    actionerKlass?: string;
  };
  mapper?: (data: any) => T;
};

export const useBulkActionsEntriesInspect = <T,>({
  filters: { actionerKlass } = {},
  mapper = Mapper.default<T>(),
}: UseBulkActionsEntriesInspectProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    ...rest
  } = useQuery({
    enabled: !!actionerKlass,
    queryKey: ['bulkActionsEntriesInspect', actionerKlass],
    queryFn: () => {
      return privateAxios.get('/bulk_actions/entries/inspect', {
        params: {
          'q[actioner_klass_eq]': actionerKlass,
        },
      });
    },
    select: (data: { data: { data: any[]; meta: MetaResponse; }; }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      };
    },
    placeholderData: keepPreviousData,
  });

  return { data, meta, ...rest };
};
